import React, { useState } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import ExternalTickets from './tickets/ExternalTickets';

const UserTicketsPage = ({ userID, phoneNumber }) => {
  const [tab, setTab] = useState('1');

  return (
    <div>
      <Nav pills className="mb-3">
        {[
          ['1', 'Ticketco'],
          ['2', 'Tickster'],
        ].map(([key, label]) => (
          <NavItem key={key}>
            <NavLink
              role="button"
              active={tab === key}
              onClick={() => setTab(key)}
            >
              {label}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      {tab === '1' && (
        <ExternalTickets
          user={userID}
          phone={phoneNumber}
          provider="ticketco"
        />
      )}
      {tab === '2' && (
        <ExternalTickets
          user={userID}
          phone={phoneNumber}
          provider="tickster"
        />
      )}
    </div>
  );
};
export default UserTicketsPage;
